import V2Root from "../layouts/V2Root";
import V2Home from "../pages/home/V2Home";
import V2Search from "../pages/search/V2Search";
import V2Dashboard from "../pages/dashboard/V2Dashboard";
import V2Users from "../pages/users/V2Users";
import V2Sites from "../pages/sites/V2Sites";
import V2Roles from "../pages/roles/V2Roles";
import ComingSoon from "../pages/placeholder/ComingSoon";
import V2Connectors from "../pages/connectors/V2Connectors";
import V2BulkExport from "../pages/bulk-export/V2BulkExport";
import ConfigureHeaderNames from "../pages/header-names/ConfigureHeaderNames";
import V2AuditLogs from "../pages/audit-logs/V2AuditLogs";
import V2SummaryTemplates from "../pages/summary-templates/V2SummaryTemplates";
import V2TranscriptionSettings from "../pages/transcription-config/V2TranscriptionSettings";
import V2Views from "../pages/views/V2Views";
import V2ViewResults from "../pages/views/V2ViewResults";
import PermissionsRestrictedRoute from "../../routes/PermissionsRestrictedRoute";
import PopoutShell from "../pages/popout/PopoutShell";
import PopoutPlayerPage from "../components/Popout/PopoutPlayerPage";
import DetachedTabPage from "../components/Popout/DetachedTabPage";

export const v2RouteChildren = {
  path: "/customers/:customerId/v2",
  element: <V2Root />,
  children: [
    { index: true, element: <V2Home /> },
    {
      path: "search",
      element: (
        <PermissionsRestrictedRoute resource="interactions" requiredPermission="Read">
          <V2Search />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "dashboard",
      element: (
        <PermissionsRestrictedRoute resource="interactions" requiredPermission="Read">
          <V2Dashboard />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "views",
      element: (
        <PermissionsRestrictedRoute resource="views" requiredPermission="*">
          <V2Views />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "views/:viewId",
      element: (
        <PermissionsRestrictedRoute resource="views" requiredPermission="*">
          <V2ViewResults />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "jobs/bulk-export",
      element: (
        <PermissionsRestrictedRoute resource="interactions" requiredPermission="Export">
          <V2BulkExport />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "users",
      element: (
        <PermissionsRestrictedRoute resource="users" requiredPermission="Read">
          <V2Users />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "sites",
      element: (
        <PermissionsRestrictedRoute resource="sites" requiredPermission="Read">
          <V2Sites />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "roles",
      element: (
        <PermissionsRestrictedRoute resource="roles" requiredPermission="Read">
          <V2Roles />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "summary-templates",
      element: (
        <PermissionsRestrictedRoute resource="summary-templates" requiredPermission="Read">
          <V2SummaryTemplates />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "connectors",
      element: (
        <PermissionsRestrictedRoute resource="connectors" requiredPermission="Read">
          <V2Connectors />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "audit-logs",
      element: (
        <PermissionsRestrictedRoute resource="auditlogs" requiredPermission="Read">
          <V2AuditLogs />
        </PermissionsRestrictedRoute>
      ),
    },
    {
      path: "extraction-dashboard",
      element: (
        <PermissionsRestrictedRoute resource="interactions" requiredPermission="Read">
          <ComingSoon title="Extraction Dashboard" />
        </PermissionsRestrictedRoute>
      ),
    },
    { path: "header-names", element: <ConfigureHeaderNames /> },
    {
      path: "transcription-config",
      element: (
        <PermissionsRestrictedRoute resource="customers" requiredPermission="Update">
          <V2TranscriptionSettings />
        </PermissionsRestrictedRoute>
      ),
    },
  ],
};

export const popoutRouteChildren = {
  path: "/customers/:customerId/v2/popout",
  element: <PopoutShell />,
  children: [
    { path: ":interactionId", element: <PopoutPlayerPage /> },
    { path: ":interactionId/tab/:tabId", element: <DetachedTabPage /> },
  ],
};
